export default "__VITE_ASSET__CpF44VvQ__"